<template>
  <div class="password">
    <div class="title">重置您的密码</div>
    <el-form :model="forgotForm" :rules="forgotRules" ref="forgotForm">
      <div class="input-item">
        <el-form-item prop="mobile">
          <el-input v-model.trim="forgotForm.mobile" placeholder="*请输入您的手机号"></el-input>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="imgCode">
          <el-input v-model.trim="forgotForm.imgCode" class="verify-input" placeholder="*请输入图形验证码"></el-input>
        </el-form-item>
        <el-form-item>
          <img class="verify-pic" @click="refreshImg" :src="captchaImg" alt />
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="code">
          <el-input v-model.trim="forgotForm.code" class="verify-input" placeholder="*请输入手机验证码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="disableSendSMS" @click="sendSMS" class="send-btn">发送验证码{{`${countdown?'('+countdown+'s)':''}`}}</el-button>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="password">
          <el-input type="password" v-model="forgotForm.password" minlength="8" maxlength="16" placeholder="*请输入您的新密码"></el-input>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="repassword">
          <el-input type="password" v-model="forgotForm.repassword" placeholder="*请再次输入您的新密码"></el-input>
        </el-form-item>
      </div>
      <el-button class="login-btn" :disabled="disableSubmit" @click="submitForm('forgotForm')">重设密码</el-button>
    </el-form>
  </div>
</template>
<script>
import types from '@/store/types';
import api from '@/utils/api';
import { captureManualError } from '@/sentry/index'

export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/.test(value)) {
        callback(new Error("密码长度为8~16个字符且包含大小写字母、数字各一个"));
      } else {
        callback();
      }
    };
    var validateRepass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forgotForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      capatchImg: api[types.CAPTCHA](),
      now: Date.now(),
      countdown: 0,
      forgotForm: {
        mobile: "",
        imgCode: "",
        code: "",
        password: "",
        repassword: ""
      },
      forgotRules: {
        mobile: [{ required: true, validator: validateMobile, trigger: "blur" }],
        imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        code: [{ required: true, message: "请输入手机验证码", trigger: "blur" }],
        password: [{ required: true, validator: validatePass, trigger: "blur" }],
        repassword: [{ required: true, validator: validateRepass, trigger: "blur" }]
      }
    };
  },
  computed: {
    captchaImg() {
      return `${this.capatchImg}?t=${this.now}`;
    },
    disableSendSMS() {
      if (this.countdown) return true;
      let { mobile, imgCode } = this.forgotForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && imgCode) {
        return false;
      }
      return true;
    },
    disableSubmit() {
      let { mobile, code, password } = this.forgotForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && code && password) {
        return false;
      }
      return true;
    }
  },
  methods: {
    refreshImg() {
      this.now = Date.now();
    },
    sendSMS() {
      api[types.SEND_SMS]({
        mobile: this.forgotForm.mobile,
        imgCode: this.forgotForm.imgCode,
        type: "forgot"
      }).then(res => {
        if (res?.code == 1) {
          this.runCountdown(60, (time) => {
            this.countdown = time;
          });
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
        captureManualError(err)
      })
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let newArgs = Object.assign({}, this.forgotForm);
          delete newArgs.imgCode;
          delete newArgs.repassword;
          api[types.FORGOT](newArgs).then(res => {
            if (res?.code == 1) {
              this.$message({
                message: "密码重置成功",
                type: "success"
              });
              setTimeout(() => {
                this.$router.push({ name: "Login" });
              }, 1000);
            } else {
              console.warn(res);
            }
          }).catch(err => {
            console.warn(err);
            captureManualError(err)
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
.password {
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .input-item {
    display: flex;
    .verify-input {
      width: 220px;
      margin-right: 10px;
    }
    .verify-pic,
    .send-btn {
      width: 100%;
      height: 40px;
      cursor: pointer;
    }
    .send-btn {
      background: #fff;
      color: #999;
      border: 1px solid #ccc;
      font-size: 14px;
      border-radius: 2px;
      &[disabled] { color: #666; background: #e7e7e7; border: 1px solid #DCDFE6; cursor: not-allowed; }
    }
  }
  .login-btn {
    width: 100%;
    height: 40px;
    color: #FFF;
    background: #7f0019;
    font-size: 14px;
    &[disabled] { color: #666; background: #e7e7e7; }
  }
}
.el-form {
  width: 70%;
  margin: 0 auto;
}
@media only screen and (max-width: 800px) {
  .password {
    .input-item {
      display: flex;
      .verify-input {
        min-width: 200px;
        width: 100%;
      }
      ::v-deep .el-form-item {
        margin-right: 10px;
      }
      .item-right {
        flex-grow: 1;
      }
    }
  }
  .el-form {
    width: 100%;
    margin: 0 auto;
  }
}
</style>